<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <base-input label="Date" style="width:100%">
          <el-date-picker type="date" v-model="expense.date"></el-date-picker>
        </base-input>
        <base-input label="Select Expense Type">
          <el-select v-model="expense.expenseTypeId">
            <el-option
              v-for="(item, index) in expenseTypes"
              :key="index"
              :value="item.expenseTypeId"
              :label="item.label"
            ></el-option>
          </el-select>
        </base-input>
      </div>
      <div class="col-md-6">
        <base-input label="Amount" v-model="expense.amount"></base-input>
        <base-input label="Description">
          <textarea
            rows="1"
            class="form-control"
            v-model="expense.description"
          ></textarea>
        </base-input>
      </div>

      <div class="col-md-12">
        <base-input label="Payment Mode">
          <el-radio-group v-model="expense.paymentModeId">
            <el-radio
              v-for="(item, index) in paymentModes"
              :label="item.paymentModeId"
              :key="index"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </base-input>
      </div>
    </div>
    <base-button md type="primary" @click="onSubmit()">Save</base-button>
  </div>
</template>
<script>
import { Select, Option, DatePicker, Radio, RadioGroup } from "element-ui";
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  data: () => {
    return {};
  },
  computed: {
    ...mapState("expense", ["expense"]),
    ...mapGetters({
      expenseTypes: "expense/getExpenseTypeList",
      paymentModes: "paymentMode/getPaymentModes",
      user: "user/getLoggedInUser"
    })
  },
  mounted() {
    this.getExpenseTypes();
    this.getPaymentModes();
    this.getExpenses();
  },
  methods: {
    ...mapActions({
      saveExpense: "expense/saveExpense",
      updateExpense: "expense/updateExpense",
      getExpenses: "expense/getExpenses",
      getExpenseTypes: "expense/getExpenseTypes",
      getPaymentModes: "paymentMode/getPaymentModes"
    }),
    onSubmit() {
      if (this.expense.expenseId) {
        this.updateExpense().then(res => {
          this.$notify({
            message: "Expense Updated Succesfully!",
            type: "success",
            title: "Succes"
          });
          this.getExpenses();
          this.$emit("close");
        });
      } else {
        this.expense.createdBy = this.user.userId;
        this.saveExpense().then(res => {
          this.$notify({
            message: "Expense Created Succesfully!",
            type: "success",
            title: "Success"
          });
          this.getExpenses();
          this.$emit("close");
        });
      }
    }
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup
  }
};
</script>
